// validators.js
/* eslint-disable */
export const errorMessages = {
    error: 'Error.',
    required: 'Required.',
    passwordFormat: 'Must contain, an uppercase, lowecase, number and a special character',
    float: 'Must be a number.',
    integer: 'Must be an integer.',
    number: 'Must be a number.',
    lessThan: 'Must be less than {0}.',
    lessThanOrEqualTo: 'Must be less than or equal to {0}.',
    greaterThan: 'Must be greater than {0}.',
    greaterThanOrEqualTo: 'Must greater than or equal to {0}.',
    between: 'Must be between {0} and {1}.',
    size: 'Size must be {0}.',
    length: 'Length must be {0}.',
    minLength: 'Must have at least {0} characters.',  
    maxLength: 'Must have up to {0} characters.',
    lengthBetween: 'Length must between {0} and {1}.',
    in: 'Must be {0}.',
    notIn: 'Must not be {0}.',
    match: 'Not matched.',
    regex: 'Invalid format.',
    digit: 'Must be a digit.',
    email: 'Invalid email.',
    url: 'Invalid url.',
    postCode: 'Invalid postcode.',
    phone: 'Invalid contact number.',
    decimal: 'Invalid',
    sortCode: 'Invalid sort code',
    account: 'Invalid account number format',
    decimalwithGreaterThan: 'Invalid format £0.00 / must be greater than {0}.',
    minBoat: 'Must have at least {0} boat.',
    promoOff: 'Must have only {0} promo.',    
    minPossession: 'Must have at least {0} high value possession.',
    minClaim: 'Must have at least {0} claim.'
  };

  
  
  export function req(value) {
    if (value === undefined || value === null || value === '') {
      return false;
    }
   
    return !!String(value).length;
  }
  
  export function len(value) {
    return String(value).length;
  }
  export function isValidPassword(value) {
    //var passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    //!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~
    var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#()+-_.:;])[A-Za-z\d@$!%*?&#()+-_.:;]{8,}$/;
    
    var match = passwordRegex.test(value);

    return match;
}

export function passwordMatch(password, confirmPassword) {
  var match = password == confirmPassword;
  return match;
}
  export function validNumber(str) { //TODO: make extension
    return typeof (str) === 'number';
  }
  export function isValidNumber(value, regex = /(\d{0,17})/) {
    if(!req(value))
      return false;
  
    var match = new RegExp(regex).test(value);
    return match;
  }
  export function isValidSortCode(value) {
    if(!req(value))
      return false;
  
    var regex = /(\d{2}-\d{2}-\d{2})|(\d{6})/;
    var match = regex.test(value);
    return match;
  }
  export function isValidTelephoneNumber(value) {
    if(!req(value))
      return false;
  
    var regex = /(\+?\d{3,4}-\d{3,4}-\d{3,4})|(\+?\d{3,4} \d{3,4} \d{3,4})|(\+?\d{10,15})/;
    var match = regex.test(value);
    return match;
  }
  export function isValidEmail(value) {
    // eslint-disable-next-line
    var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
    var match = emailRegex.test(value);
    return match;
  }
  export function isValidAmount(min, value){
    var regex  = /^\$?\d+(,\d{3})*(\.\d{1,20})?$/;
    var valid =  regex.test(value) && parseFloat(value) >= min ; 
    return valid;
  }
  export function isValidPostcode(value) {
    // eslint-disable-next-line
    value = value.replace(/\s/g, "");
    
    var postCodeRegex = /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/g;
    var match = postCodeRegex.test(value);
  
    return match;
  }
  
  export function minLength(length, value) {
    var valid = !req(value) || len(value) >= length;
    return valid;
  }
  export function mustEqual(length, value) {
    var valid = !req(value) || parseInt(value) == length;
    return valid;
  }
  export function minValue(min, value) {
    var valid = !req(value) || parseInt(value) >= min;
    return valid;
  }
  export function lengthBetween(minLength, maxLength, value) {
    var valid = !req(value) || (len(value) >= minLength && len(value) <= maxLength);
    return valid;
  }
  export function isNameJoe(value) {
    if (!value) return true;
    return value === "Joe";
  }
  
  export function notGmail(value = "") {
    return !value.includes("gmail");
  }
  
  export function isEmailAvailable(value) {
    if (value === "") return true;
  
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(value.length > 10);
      }, 500);
    });
  }
  export function validateField(prop, reqs) {
    // eslint-disable-next-line no-unused-vars
    function reject(msg) {
      console.error(`Error in property "${prop}" : ${msg}`);
      return false;
    }
    // eslint-disable-next-line no-unused-vars
    function typeOf(obj) {
      return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1];
    }
  
    
    return true;
  }
  
  export function validateTypes(cname, pname, prop, reqs) {
    function reject(msg) {
      console.error(`Error in property "${pname}" of component ${cname}: ${msg}`);
      return false;
    }
    function typeOf(obj) {
      return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1];
    }
    for (let k of Object.keys(reqs)) {
      if (reqs[k].required && !prop[k])
        return reject(`property "${k}" is required`);
      if (!prop[k]) continue;
      if (reqs[k].type && typeOf(prop[k]) != reqs[k].type)
        return reject(`property "${pname}.${k}" should be of type ${reqs[k].type}`);
    }
    return true;
  }
  
  export function getNestedField(obj, path) {
    return path.split('.').reduce(
      (prev, curr) => prev ? prev[curr] : undefined,
      obj
    );
  }
  
  export function setNestedField(obj, path, value) {
    let parts = path.split('.');
    let last = parts.pop();
    let parent = parts.reduce(
      (prev, curr) => {
        if (prev[curr] === undefined)
          prev[curr] = {};
        return prev[curr];
      },
      obj
    );
    if (parent) parent[last] = value;
  }
  
  
  export function upperCasefirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  
  export function wrapAsyncFunction(before, asyncF, after) {
    return function (...params) {
      before(...params);
      return asyncF(...params)
        .then(x => {
          after(...params);
          return x;
        })
        .catch(x => {
          after(...params);
          throw x;
        });
    };
  }
  